"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMIDI = void 0;
const react_1 = require("react");
const WebMidi = require("webmidi");
exports.useMIDI = () => {
    const [inputs, setInputs] = react_1.useState();
    const [outputs, setOutputs] = react_1.useState();
    const [getOutputById, setGetOutputById] = react_1.useState({ getter: undefined });
    const [getInputById, setGetInputById] = react_1.useState({ getter: undefined });
    const [accessError, setAccessError] = react_1.useState();
    WebMidi.enable((err) => {
        if (err) {
            setAccessError(err);
            console.log(err);
        }
        setInputs(WebMidi.inputs);
        setOutputs(WebMidi.outputs);
        setGetOutputById({ getter: (id) => WebMidi.getOutputById(id) });
        setGetInputById({ getter: (id) => WebMidi.getInputById(id) });
    });
    return {
        getOutputById: getOutputById.getter,
        getInputById: getInputById.getter,
        inputs,
        outputs,
        accessError,
    };
};
//# sourceMappingURL=useMIDI.js.map